/** Icônes 16 px pour les menus devis. */
import type { ReactNode } from "react";

function Ico({ children }: { children: ReactNode }) {
  return (
    <svg className="fx-menu-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      {children}
    </svg>
  );
}

export function IcoMail() {
  return (
    <Ico>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3 7 9 7 9-7" />
    </Ico>
  );
}

export function IcoEye() {
  return (
    <Ico>
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
      <circle cx="12" cy="12" r="2.5" />
    </Ico>
  );
}

export function IcoPrint() {
  return (
    <Ico>
      <path d="M7 8V4h10v4" />
      <rect x="5" y="8" width="14" height="8" rx="1.5" />
      <path d="M7 16h10v4H7z" />
    </Ico>
  );
}

export function IcoEdit() {
  return (
    <Ico>
      <path d="M4 20h4l10-10-4-4L4 16v4z" />
      <path d="m12 6 4 4" />
    </Ico>
  );
}

export function IcoCopy() {
  return (
    <Ico>
      <rect x="8" y="8" width="12" height="12" rx="2" />
      <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" />
    </Ico>
  );
}

export function IcoInvoice() {
  return (
    <Ico>
      <path d="M7 3h10v18l-2-1.4-2 1.4-2-1.4-2 1.4-2-1.4z" />
      <path d="M9 8h6M9 12h6M9 16h3" />
    </Ico>
  );
}

export function IcoSeal() {
  return (
    <Ico>
      <path d="M12 3l7 3v6c0 5-3.2 8.2-7 9-3.8-.8-7-4-7-9V6l7-3z" />
      <path d="m8.5 12 2.4 2.4 4.6-5" />
    </Ico>
  );
}

export function IcoPay() {
  return (
    <Ico>
      <circle cx="12" cy="12" r="8.5" />
      <path d="m8.5 12.2 2.4 2.3 4.6-5" />
    </Ico>
  );
}

export function IcoCollect() {
  return (
    <Ico>
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <path d="M2 10h20" />
      <path d="M6 15h4" />
    </Ico>
  );
}

export function IcoPause() {
  return (
    <Ico>
      <path d="M8 5v14M16 5v14" />
    </Ico>
  );
}

export function IcoRepeat() {
  return (
    <Ico>
      <path d="M17 1v4h-4" />
      <path d="M7 23v-4h4" />
      <path d="M20.5 9A8 8 0 0 0 6 7.5L3 11" />
      <path d="M3.5 15A8 8 0 0 0 18 16.5L21 13" />
    </Ico>
  );
}

export function IcoCredit() {
  return (
    <Ico>
      <path d="M6 7h12v13H6z" />
      <path d="M9 4h6v3H9z" />
      <path d="M9 14h6" />
    </Ico>
  );
}

export function IcoStop() {
  return (
    <Ico>
      <rect x="6" y="6" width="12" height="12" rx="1.5" />
    </Ico>
  );
}

export function IcoTrash() {
  return (
    <Ico>
      <path d="M4 7h16" />
      <path d="M10 7V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2" />
      <path d="M6 7l1 13h10l1-13" />
      <path d="M10 11v6M14 11v6" />
    </Ico>
  );
}
